import {
  unloadApplication,
  getMountedApps,
  checkActivityFunctions,
} from "single-spa";

/**
 * Desmonta as aplicações montadas para para uma determinada url.
 * @param url - A url as quais os apps devem ser desmontados.
 * @returns Uma promise que resolve ou rejeita em caso de erro ao desmontar algum app.
 */
async function unloadActivity(
  location: Location
): Promise<{ appNames: string[]; error: null | Error }> {
  const mountedApps = getMountedApps();

  // O tipo do parametro da função `checkActivityFunctions` parece estar errado.
  // acompanhar issue aberta: https://github.com/single-spa/single-spa/issues/1000
  // @ts-ignore
  const appsThatShouldMount = checkActivityFunctions(location);

  let appsToUnmount: string[] = [];

  if (appsThatShouldMount.length) {
    appsToUnmount = mountedApps.filter((appName) =>
      appsThatShouldMount.includes(appName)
    );
  }

  const unloadPromises: Array<Promise<{ appName: string; error: null }>> = [];

  if (appsToUnmount.length) {
    appsToUnmount.forEach((appName) => {
      const promise = unloadApplication(appName, { waitForUnmount: false })
        .then(() => ({ appName, error: null }))
        .catch((error) => ({ appName, error }));
      unloadPromises.push(promise);
    });
  }

  return await Promise.all(unloadPromises)
    .then((apps) => ({
      appNames: apps.map(({ appName }) => appName),
      error: null,
    }))
    .catch(() => ({ appNames: [], error: new Error() }));
}

export default unloadActivity;
